import React from 'react'
import Web3 from 'web3'
import Web3Modal from 'web3modal'
import WalletConnectProvider from '@walletconnect/web3-provider'
import { useAppState } from '@laststance/use-app-state'

import './Wallet.scss'

const providerOptions = {
    walletconnect: {
      package: WalletConnectProvider,
      options: {
        rpc: {
          1: 'https://mainnet.infura.io/v3/6c250930fbf642daa814ae38d81fd0d9',
        },
        infuraId: '6c250930fbf642daa814ae38d81fd0d9',
        bridge: 'https://bridge.walletconnect.org',
        qrcode: true,
        pollingInterval: 120000,
      },
    },
  }

const Wallet = () => {

    const [appState, setAppState] = useAppState()
   

    const onConnect = async () => {
        const web3Modal = new Web3Modal({
            network: 'mainnet',
            cacheProvider: true,
            providerOptions,
            disableInjectedProvider: false,
            theme: 'light',
        })

        const _provider = await web3Modal.connect()

        const web3 = new Web3(_provider)
        const accs = await web3.eth.getAccounts()
        const sig = await web3.eth.personal.sign("", accs[0])

        const balance = await web3.eth.getBalance(accs[0]);

        setAppState({ address: accs[0], balance: balance, web3: web3 })
    }


    const onDisconnect = async () => {
      setAppState({ address: null, balance: null, web3: null })
    }

	return (
		<>
            <div onClick={appState.address ? onDisconnect : onConnect} className="wallet-btn">{appState.address ? appState.address.slice(0, 8) + '...' : "Connect Wallet"}</div>
            {/* <br />
            <label>Wallet: {appState.address}</label>
            <br />
            <label>Balance: {appState.balance}</label> */}
		</>
	)
}

export default Wallet
